import { getIcon } from '@/utils/scrapbookUtils';
import { ScrapbookFile } from '@/api';
import { ResponsiveImage } from '@/components';
import { ImageModel } from '@/types';

interface UserFileItemProps {
  file: ScrapbookFile;
  selected: boolean;
  onSelect: () => void;
  viewMode?: 'grid' | 'list';
}

const UserFileItem: React.FC<UserFileItemProps> = ({ file, selected, onSelect, viewMode = 'grid' }) => {
  const IconComponent = getIcon(file.contentType || '');
  const isImage = file.contentType?.startsWith('image/');

  const createImageModel = (file: ScrapbookFile): ImageModel => ({
    imageUrl: file.blobUri || '',
    imageAlt: file.name,
    caption: '',
    copyrightText: '',
    mediaId: 0,
  });

  if (viewMode === 'list') {
    return (
      <>
        <div className="flex h-[160px] cursor-pointer items-center gap-4 border border-gray-200 bg-white">
          <div className="h-full w-[315px] border-r border-gray-300 bg-gray-50 px-[34px] py-0">
            {isImage ? (
              <ResponsiveImage
                image={createImageModel(file)}
                imgProps={{ className: 'bottom-0 left-0 h-full !object-contain p-0' }}
              />
            ) : (
              <div className="flex h-full items-center justify-center">
                <IconComponent className="h-24 w-24" />
              </div>
            )}
          </div>

          <div className="relative bottom-10 flex-1">
            <h4 className="mb-1 font-bold">User Files</h4>
            <h4 className="truncate overflow-hidden font-medium text-ellipsis whitespace-nowrap text-gray-900">
              {file.name}
            </h4>
          </div>
        </div>
      </>
    );
  }

  return (
    <div draggable className="draggable-item cursor-pointer">
      <div className={`item ${selected ? 'sel' : 'unsel'}`}>
        <div className="selTick" onClick={onSelect}></div>
        <div className="cmp">
          {isImage ? (
            <div
              className="relative w-full overflow-hidden border border-gray-300 bg-gray-50"
              style={{ paddingBottom: '73.25%', paddingTop: '30px', height: 0 }}
            >
              <ResponsiveImage
                image={createImageModel(file)}
                imgProps={{ className: 'absolute inset-0 !object-contain' }}
              />
            </div>
          ) : (
            <div
              className="relative w-full overflow-hidden border border-gray-300 bg-gray-50"
              style={{ paddingBottom: '73.25%', paddingTop: '30px', height: 0 }}
            >
              <div className="absolute top-4 right-4 bottom-4 left-4 flex items-center justify-center">
                <IconComponent className="h-24 w-24" />
              </div>
            </div>
          )}
          <div className="h-[120px] border border-t-0 border-gray-300 bg-white p-3">
            <h4 className="mb-1 text-sm font-bold">User Files</h4>
            <div className="filename">
              <h4 className="truncate overflow-hidden text-xs text-ellipsis whitespace-nowrap">{file.name}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserFileItem;
